import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Geralmente importa um arquivo de estilos globais
import App from './App'; // Importa o seu componente principal App

// Encontra a div com id="root" no seu arquivo public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderiza (desenha) sua aplicação React dentro daquela div
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);